import { render } from "./CreateSubstituteForm.vue?vue&type=template&id=28b85a00"
import script from "./CreateSubstituteForm.vue?vue&type=script&lang=js"
export * from "./CreateSubstituteForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__